import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const SiteVisitResultsAnalyzedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SITE_VISIT_RESULTS_ANALYZED),
  shouldCreateNewBid: z.boolean(),
  createdBidId: z.number().optional(),
  // Seed-only: rides into the new bid's creation write, since its REVIEW_BID auto-completes and evaluates there.
  seedBidDataOverrides: z.object({ isPropertyModelDetailRequired: z.boolean().optional() }).optional(),
});

export type SiteVisitResultsAnalyzedTaskAttempt = z.infer<typeof SiteVisitResultsAnalyzedTaskAttemptSchema>;
